/**
 * wilout/issues#9787 — Listes de contrôle cochées dans le panneau d'un accès.
 *
 * Les cases des pages du BO partagent la classe `.liLK` sans porter d'id : seules celles du bloc
 * `.conflistK` sont des listes, sinon chaque page cochée devient un `null` dans `enableList`.
 */
export function listesCochees(panneau: ParentNode): string[] {
  return Array.from(panneau.querySelectorAll<HTMLElement>('.conflistK .liLK[mod1="checked"]'), li => li.id);
}
